import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Divider } from 'antd';
import { useTranslation } from 'react-i18next';
import { ICON_STEP_4, ICON_STEP_5 } from './IconStep';
import ProgressBar from './ProgressBar';
import Sticky from 'react-sticky-el';
import { PlusOutlined } from '@ant-design/icons';
import { useState } from 'react';
import ModalAddNote from './ModalAddNote';
import parse from 'html-react-parser';
import ModalDelete from '../../../../../components/Shared/modal/delete';
import TemplateDesignService from '../../../../../services/TemplateDesign.service';
import useNotify from '../../../../../context/Notification/useNotify';

const Step5 = (props) => {
    const { t, i18n } = useTranslation('consent');
    const [openModal, setOpenModal] = useState(false);
    const [mode, setMode] = useState('');
    const [noteObject, setNoteObject] = useState('');
    const [loadingDelete, setLoadingDelete] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const notify = useNotify();
    const deleteNote = async (noteId, templateId) => {
        setLoadingDelete(true);
        if (templateId !== undefined || templateId != null) {
            try {
                const { data } = await TemplateDesignService.deleteNote(
                    templateId,
                    noteId
                );
                if (data?.resultMsg === 'SUCCESS') {
                    setOpenDelete(false);
                    setLoadingDelete(false);
                    props?.setRemoveNote(noteId);
                    props?.setTriggerNote(true);
                    const newArr = props?.combinedDragData.filter(
                        (item) => item.noteId !== noteId
                    );
                    props.setCombinedDragData(newArr);
                    notify({
                        title: t('Success'),
                        description: t('Successfully deleted data'),
                        timeOut: 1800,
                    });
                } else {
                    setOpenDelete(false);
                    setLoadingDelete(false);
                    notify({
                        type: 'error',
                        title: t('Fail'),
                        description: t('Failed to deleted'),
                    });
                }
            } catch (error) {
                const err = error?.data;
                console.log(err);
            }
        } else {
            props?.setRemoveNote(noteId);
            setOpenDelete(false);
            setLoadingDelete(false);
        }
    };
    const onPreviousStep = () => {
        props.previousStep();
    };
    return (
        <>
            <div className="bg-white p-4 rounded-lg">
                <Sticky
                    boundaryElement=".block_"
                    stickyClassName="bg-white p-4 shadow rounded-lg z-50"
                >
                    <Button
                        size="large"
                        className="!border-purple !text-purple"
                        onClick={onPreviousStep}
                    >
                        <ArrowLeftOutlined /> {t('Previous Step')}
                    </Button>
                </Sticky>
                <Divider />
                <div className="flex space-x-2 items-center">
                    {ICON_STEP_5}
                    <div>
                        <div className="text-base font-medium text-[#65707A]">
                            {t('Step')} 5 / 5
                        </div>
                        <div className="text-xl font-semibold">
                            {t('Step4')}
                        </div>
                    </div>
                </div>
                <ProgressBar percent={100} />
                {/* <div className="h-[60vh] overflow-y-auto pr-2"> */}
                <p
                    className="text-new font-semibold text-base	cursor-pointer space-x-2 items-center"
                    onClick={() => {
                        setMode('addNote');
                        setOpenModal(true);
                    }}
                >
                    <PlusOutlined />
                    <span className="underline">{t('add note')}</span>
                </p>
                {props?.notes &&
                    props?.notes.map((note) => (
                        <div
                            key={note?.noteId}
                            className="bg-[#F4F6FC] p-4 rounded-lg flex justify-between mb-4"
                        >
                            <div className="text-sm font-normal	text-gray-dark mb-2">
                                {i18n === 'EN'
                                    ? parse(note?.titleEn)
                                    : parse(note?.titleTh)}
                            </div>
                            <div className="flex flex-col">
                                <div
                                    onClick={() => {
                                        setMode('editNote');
                                        setOpenModal(true);
                                        setNoteObject(note);
                                    }}
                                    className="cursor-pointer"
                                >
                                    <svg
                                        width="32"
                                        height="32"
                                        viewBox="0 0 32 32"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <rect
                                            width="32"
                                            height="32"
                                            rx="6"
                                            fill="#EEE5FF"
                                        />
                                        <path
                                            d="M20.6583 9.3418L22.6583 11.3418L21.1337 12.8671L19.1337 10.8671L20.6583 9.3418ZM13.333 18.6671H15.333L20.191 13.8091L18.191 11.8091L13.333 16.6671V18.6671Z"
                                            fill="#7B67FB"
                                        />
                                        <path
                                            d="M20.6667 20.6667H13.4387C13.4213 20.6667 13.4033 20.6733 13.386 20.6733C13.364 20.6733 13.342 20.6673 13.3193 20.6667H11.3333V11.3333H15.898L17.2313 10H11.3333C10.598 10 10 10.5973 10 11.3333V20.6667C10 21.4027 10.598 22 11.3333 22H20.6667C21.0203 22 21.3594 21.8595 21.6095 21.6095C21.8595 21.3594 22 21.0203 22 20.6667V14.888L20.6667 16.2213V20.6667Z"
                                            fill="#7B67FB"
                                        />
                                    </svg>
                                </div>
                                <div
                                    onClick={() => {
                                        setOpenDelete(true);
                                        setNoteObject(note);
                                    }}
                                    className="cursor-pointer"
                                >
                                    <svg
                                        width="32"
                                        height="32"
                                        viewBox="0 0 32 32"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <rect
                                            width="32"
                                            height="32"
                                            rx="6"
                                            fill="#EEE5FF"
                                        />
                                        <path
                                            d="M15.9998 9C16.5487 8.99992 17.0778 9.20504 17.4832 9.57509C17.8887 9.94513 18.1411 10.4534 18.191 11H21.5998C21.7518 11 21.8982 11.0578 22.0092 11.1616C22.1203 11.2654 22.1879 11.4074 22.1982 11.5591C22.2086 11.7108 22.161 11.8607 22.0651 11.9786C21.9691 12.0966 21.832 12.1737 21.6814 12.1944L21.5998 12.2H21.1334L20.1198 20.984C20.0747 21.3739 19.8878 21.7336 19.5947 21.9947C19.3016 22.2558 18.9227 22.4001 18.5302 22.4H13.4694C13.0769 22.4001 12.698 22.2558 12.4049 21.9947C12.1118 21.7336 11.9249 21.3739 11.8798 20.984L10.8654 12.2H10.3998C10.2548 12.2 10.1147 12.1475 10.0055 12.0522C9.89619 11.9569 9.82512 11.8252 9.8054 11.6816L9.7998 11.6C9.79981 11.455 9.85232 11.3149 9.94762 11.2057C10.0429 11.0964 10.1746 11.0253 10.3182 11.0056L10.3998 11H13.8086C13.8585 10.4534 14.1109 9.94513 14.5164 9.57509C14.9218 9.20504 15.4509 8.99992 15.9998 9ZM14.7998 14C14.6038 14 14.4398 14.124 14.4062 14.2872L14.3998 14.3504V19.2504L14.4062 19.3128C14.4398 19.476 14.6038 19.6 14.7998 19.6C14.9958 19.6 15.1598 19.476 15.1934 19.3128L15.1998 19.2496V14.3512L15.1934 14.2872C15.1598 14.1248 14.9958 14 14.7998 14ZM17.1998 14C17.0038 14 16.8398 14.124 16.8062 14.2872L16.7998 14.3504V19.2504L16.8062 19.3128C16.8398 19.476 17.0038 19.6 17.1998 19.6C17.3958 19.6 17.5598 19.476 17.5934 19.3128L17.5998 19.2496V14.3512L17.5934 14.2872C17.5598 14.1248 17.3958 14 17.1998 14ZM15.9998 10.2C15.5158 10.2 15.1118 10.544 15.0198 11H16.9798C16.887 10.544 16.4838 10.2 15.9998 10.2Z"
                                            fill="#7B67FB"
                                        />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    ))}
            </div>
            <ModalAddNote
                mode={mode}
                open={openModal}
                handelClose={() => {
                    setNoteObject('');
                    setOpenModal(false);
                }}
                setAddNote={props?.setAddNote}
                setTriggerNote={props?.setTriggerNote}
                templateId={props?.editObject?.templateId}
                version={props?.editObject?.version}
                noteObject={noteObject}
                edit={props?.edit}
                setNotes={props?.setNotes}
                notes={props?.notes}
                addNote={props?.addNote}
                triggerNote={props?.triggerNote}
                combinedDragData={props?.combinedDragData}
                setCombinedDragData={props?.setCombinedDragData}
                setFakeNote={props?.setFakeNote}
            />
            <ModalDelete
                loading={loadingDelete}
                open={openDelete}
                title={t('ConfirmDelete')}
                text={t('ConfirmDeleteDetail')}
                handelOk={
                    // handelDelete
                    () => {
                        deleteNote(
                            noteObject?.noteId,
                            props?.editObject?.templateId
                        );
                    }
                }
                handelClose={() => {
                    setOpenDelete(false);
                    setLoadingDelete(false);
                }}
            />
        </>
    );
};

export default Step5;
